<app-crud-table
  heading="DAISE indexes"
  itemTypeName="Index"
  [items]="items"
  [columns]="columns"
  [loading]="loading"
  (toggle)="toggle($event)"
  (delete)="delete($event)"
  (showItemDialog)="onShowItemDialog($event)"
></app-crud-table>

<p-dialog [(visible)]="showItemDialog" [style]="{ width: '65%' }" [modal]="true" (onHide)="onIndexDialogCancel()">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center">
      <span class="p-dialog-title">
        {{ getDialogHeader() }}
      </span>
      <p-button
        (onClick)="fillDefault()"
        pRipple
        [rounded]="true"
        [outlined]="true"
        class="p-button-text"
        icon="pi pi-file"
        label="Fill default"
      ></p-button>
    </div>
  </ng-template>
  <app-new-daise-index-dialog
    *ngIf="showItemDialog"
    [editedItem]="clonedItem"
    [processing]="processing$ | async"
    (indexAdded)="handleAddIndex($event)"
    (indexEdited)="handleEditIndex($event)"
    (indexCancelled)="onIndexDialogCancel()"
    (loadingErrorOccured)="onIndexDialogCancel()">
  </app-new-daise-index-dialog>
</p-dialog>

<ng-template #roleTemplate  let-item="item">
  <div class="d-flex flex-column">
    @for (role of item.roles ; track role) {
      <div>{{role}}</div>
    }
  </div>
</ng-template>
